// PnLTimeSeriesDx.tsx
import React, { useMemo, useEffect, useState, useRef } from "react";
import Chart, {
  Series,
  ArgumentAxis,
  ValueAxis,
  Tooltip,
  Legend,
  ZoomAndPan,
  ScrollBar,
  CommonAxisSettings,
  ConstantLine, CommonSeriesSettings, Title
} from "devextreme-react/chart";
import { escapeRegExp } from "devextreme/core/utils/common";
import { formatDate } from "devextreme/localization";
import { Label } from "devextreme-react/pie-chart";

import { numberFmt } from '../../utils/formatUtils';
import { baseUrl } from '../../hooks/useFetch';

interface VARBacktestChartProps {
  page: string;
  chart_data: ChartDataPoint[];
}

interface ChartDataPoint {
  cob_date: string | Date;
  pnl_daily: number;
  daily_var: number;
  book?: string;
}

const VARBacktestChart: React.FC<VARBacktestChartProps> = ({ page, chart_data }) => {

  const dateFmt = (d: Date): string =>
    new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(d);



function getRandom(min: number, max: number): number {
  return Math.random() * (max - min) + min;
}

function customizeTooltip1(arg: any) {
  const date = arg.argument.toLocaleDateString();
  const lines = arg.points.map((p: any) => `${p.seriesName}: ${p.valueText}`);
  return { text: `${date}\n${lines.join("\n")}` };
}
function customizePoint(arg: any) {
  const d = arg.data;
  if (arg.seriesName === "PnL" && d && d.pnl_daily < d.daily_var) {
    return { color: "yellow"  };
  }
  return {};
}

  const chartRef = useRef<any>(null);


  const handleLegendClick = (e: any) => {
    const series = e.target;
    if (!series) return;
    series.isVisible() ? series.hide() : series.show();
  };


  const customizeTooltip = (info: any) => {
    const points = info.points || [info];
    const lines = [
      `<div  style="text-align:center; white-space:pre;"><strong>${formatDate(points[0].argument, "dd-MMM")}</strong></div>`,
      ...points.map((p: any) => {
        const display = p.seriesName;
        return `<div style="text-align:right;; white-space:pre;">${display}:  ${numberFmt(p.value)}</div>`;
      }),
    ];
    return { html: lines.join("") };
  };
const fyStart = new Date(2025, 3, 1);            // Apr = month 3 (0-based)
const fyEnd   = new Date(2026, 2, 31, 23,59,59);
  return (
    <div style={{ width: "100%", height: "80%" }} >
      <Chart dataSource={chart_data} size={{ height: 600 }}   style={{
        width: "95%",
        margin: "0 auto",
        marginTop: 24 }}
       onLegendClick={handleLegendClick} customizePoint={customizePoint}
      >
        <CommonSeriesSettings argumentField="cob_date" />
        <ZoomAndPan argumentAxis="both" />
        <ScrollBar visible={true} />
        <Series
          valueField="pnl_daily"
          name="PnL"
          type="bar"
        />
        <Series
          valueField="daily_var"
          name="VaR 1d 95%"
          type="line"
          point={{ visible: false }}
        />

        <ArgumentAxis
          argumentType="datetime"
           label={{font: { size: 14 },
           customizeText: (e: any) =>

                formatDate(e.value, "MMM dd"),
          }}
        />
               <ValueAxis>
          <Label customizeText={(e: any) =>
            (e.value / 1_000).toLocaleString(undefined, { maximumFractionDigits: 2 })
          } />
        </ValueAxis>
        <Legend visible={true}           position="outside"
          orientation="horizontal"
          verticalAlignment="bottom"
          horizontalAlignment="center"/>
        <Title text={page}   horizontalAlignment="center"  />

        <Tooltip
          enabled={true}
          shared={true}
          format={{ type: "fixedPoint", precision: 0 }}
          customizeTooltip={customizeTooltip}
        />
      </Chart>

    </div>
  );
};

export default VARBacktestChart;
